import { OtherPanel } from './WalletShared';
import { PriceChart } from '../PriceChart';
import { COLORS, WALLET_COLORS as C } from '@/constants';

type Translate = (key: string) => string;
type SparkPoint = { t: string; price: number };

export function PriceTrendCard({ t, sparkData, onViewMarket }: { t: Translate; sparkData: SparkPoint[]; onViewMarket: () => void }) {
  return (
    <OtherPanel className="p-4">
      <div className="mb-3 flex items-start justify-between">
        <div className="flex flex-col gap-0.5">
          <div className="flex items-end gap-1.5">
            <span className="text-2xl font-semibold leading-none" style={{ color: COLORS.iconGlobal }}>¥{sparkData[sparkData.length - 1]?.price.toFixed(4) ?? '—'}</span>
            <span className="text-[11px] font-semibold leading-none" style={{ color: C.arrowKey }}>EP</span>
          </div>
          <div className="text-[11px]" style={{ color: COLORS.iconGlobal }}>{t('wallet.ep30dTrend')}</div>
        </div>
        <button type="button" onClick={onViewMarket} className="mt-1 flex items-center gap-0.5 text-[11px] text-white">
          {t('wallet.viewMarket')}
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none"><path fillRule="evenodd" clipRule="evenodd" d="M12.6278 7.50001L7.99714 2.86938C7.72255 2.59479 7.72255 2.1496 7.99714 1.87501C8.27173 1.60042 8.71692 1.60042 8.99151 1.87501L13.9536 6.8371C14.3197 7.20321 14.3197 7.7968 13.9536 8.16292L8.99151 13.125C8.71692 13.3996 8.27173 13.3996 7.99714 13.125C7.72255 12.8504 7.72255 12.4052 7.99714 12.1306L12.6278 7.50001Z" fill={C.arrowKey}/></svg>
        </button>
      </div>
      <PriceChart data={sparkData} width={319} height={100} sparkline color={C.chartColor} showHighestLabel />
      <div className="mt-1 flex justify-between px-1 text-[11px]" style={{ color: COLORS.iconColor }}>
        {[0, 7, 14, 21, 29].map(i => <span key={i}>{sparkData[i] ? sparkData[i].t.slice(5) : ''}</span>)}
      </div>
    </OtherPanel>
  );
}

